import React__default from 'react';
import './Tag.scss.js';
import { classnames } from '../../../utils/classnames.js';
import AllClose from '../../../assets/icons/resultDir/AllClose.js';

var Tag = function Tag(_ref) {
  var children = _ref.children,
      icon = _ref.icon,
      onClick = _ref.onClick,
      onRemove = _ref.onRemove,
      disabled = _ref.disabled,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      _ref$maxLength = _ref.maxLength,
      maxLength = _ref$maxLength === void 0 ? 32 : _ref$maxLength,
      style = _ref.style,
      className = _ref.className;

  var handleClick = function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    onClick && onClick();
  };

  var handleRemove = function handleRemove(e) {
    e.stopPropagation();
    onRemove && onRemove();
  }; // -------------------------------------------------------------------------------------------------------------------


  var clickableClass = onClick && !disabled ? 'rf-tag--clickable' : ''; // -------------------------------------------------------------------------------------------------------------------

  var overMaxLength = typeof children === 'string' && children.length > maxLength; // -------------------------------------------------------------------------------------------------------------------

  return /*#__PURE__*/React__default.createElement("div", {
    className: classnames('rf-tag', clickableClass, "rf-tag--".concat(variant), className),
    onClick: onClick ? handleClick : undefined,
    style: style,
    "data-v-6e52f9c7": ""
  }, !!icon && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-tag__icon",
    "data-v-6e52f9c7": ""
  }, icon), overMaxLength ? children.slice(0, maxLength) + '...' : children, !!onRemove && /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: "rf-tag__remove",
    onClick: handleRemove,
    disabled: disabled,
    "aria-label": "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement(AllClose, {
    "data-v-6e52f9c7": ""
  })));
};

export { Tag as default };
